import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const BodyRegular = ({
  tag: Tag = "p",
  children,
  className,
  color,
  weight = 400,
  style,
  ...rest
}) => (
  <Tag
    className={classNames(
      "m-0",
      "text-sm",
      "font-normal",
      "text-black",
      "leading-140",
      className
    )}
    style={{
      ...(color ? { color } : {}),
      ...(weight != null ? { fontWeight: weight } : {}),
      ...style
    }}
    {...rest}
  >
    {children}
  </Tag>
);

BodyRegular.propTypes = {
  tag: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object
};

export default BodyRegular;
